/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2023. All Rights Reserved.
 #*
 #*===================================================================
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiManagementConfigDTO } from '@settings/api-management/shared';
import { environment } from 'environments/environment';
import { ApiResponse } from '@core/models';

@Injectable({ providedIn: 'root' })
export class ApiManagementService {
  constructor(private http: HttpClient) {}

  getConfigs(): Observable<ApiResponse<ApiManagementConfigDTO[]>> {
    return this.http.get<ApiResponse<ApiManagementConfigDTO[]>>(`${environment.superAdmin}/api-management`);
  }

  createConfig(payload: Partial<ApiManagementConfigDTO>): Observable<ApiResponse<ApiManagementConfigDTO>> {
    return this.http.post<ApiResponse<ApiManagementConfigDTO>>(`${environment.superAdmin}/api-management`, payload);
  }

  updateConfig(payload: Partial<ApiManagementConfigDTO>): Observable<ApiResponse<ApiManagementConfigDTO>> {
    return this.http.put<ApiResponse<ApiManagementConfigDTO>>(
      `${environment.superAdmin}/api-management/${payload.id}`,
      payload
    );
  }

  deleteConfig(id: number): Observable<ApiResponse<number>> {
    return this.http.delete<ApiResponse<number>>(`${environment.superAdmin}/api-management/${id}`);
  }
}
